export const translations = {
  en: {
    appName: 'MyTownly',
    tagline: 'Delivery Partner · Piler',
    langToggle: 'తెలుగు',
    nav: { home: 'Home', history: 'History', profile: 'Profile' },
    common: { back: 'Back', save: 'Save', cancel: 'Cancel', loading: 'Loading...' },
    notifications: {
      title: 'Delivery alerts',
      desc: 'Get push alerts when new grocery pickups are ready near you',
      enable: 'Enable',
      enabled: 'Notifications on! You’ll get new delivery alerts 🔔',
      blocked: 'Notifications blocked — enable in phone settings',
      failed: 'Could not enable notifications',
    },
    dashboard: {
      online: 'ONLINE', offline: 'OFFLINE',
      youAreOnline: "You're Online!", youAreOffline: "You're Offline",
      waitingDelivery: 'Waiting for delivery orders...',
      tapOnline: 'Tap to go online', goOnline: 'Go Online →',
      approvalPending: 'Approval pending ⏳',
      adminApproval: 'Admin approval required before going online',
      approveToast: 'Approved! You can go online now.',
      blocked: 'Your account is blocked. Contact MyTownly support.',
      todayJobs: "Today's Jobs", totalJobs: 'Total Jobs',
      rating: 'Rating', status: 'Status', approved: 'Approved ✓', pending: 'Pending ⏳',
      noRating: 'New', ratingValue: '{rating} ⭐',
      waitingApproval: 'Waiting for Approval',
      waitingApprovalSub: 'The MyTownly team will approve you shortly. You can go online once approved.',
      howItWorks: 'How it works',
      tip1: 'Accept delivery when the shop confirms the order',
      tip2: 'Collect cash from customer if order is COD',
      tip3: 'Mark picked up → delivered in the app',
      continueDelivery: 'Delivery in progress',
      continueDeliverySub: '{status} — tap to continue',
      statusReady: 'Go to shop', statusPickedUp: 'On the way to customer',
      newDelivery: 'NEW DELIVERY ORDER', deliverTo: 'DELIVER TO',
      acceptDelivery: '✓ Accept Delivery', skip: '✕ Skip', orderSkipped: 'Order skipped',
      deliveryAccepted: 'Delivery accepted! 📦', acceptFailed: 'Could not accept. Try again.',
      orderTaken: 'Another rider already took this order', orderNotAvailable: 'This order is no longer available',
      distanceToYou: 'To you', distanceDelivery: 'Delivery route',
      locationDenied: 'Location blocked — allow location for rider.mytownly.in in browser/phone settings.',
      locationWeak: 'GPS not ready yet — you are still online. Move outdoors or wait a moment for location.',
    },
    tour: {
      skip: 'Skip',
      next: 'Next →',
      gotIt: 'Got it! 👍',
      welcomeIcon: '📦',
      welcomeTitle: 'Welcome, delivery partner!',
      welcomeBody: 'We’ll point out the key buttons — takes 30 seconds.',
      onlineIcon: '🟢',
      onlineTitle: 'Go online here',
      onlineBody: 'After admin approval, tap this circle or Go Online. Allow location & notifications.',
      acceptIcon: '✓',
      acceptTitle: 'Accept deliveries',
      acceptBody: 'When a shop marks Ready, a popup appears here. Tap Accept on the order card.',
      deliverIcon: '🏁',
      deliverTitle: 'Complete & history',
      deliverBody: 'Mark Picked up → Delivered in the active screen. Past jobs are in History below.',
    },
    delivery: {
      active: 'ACTIVE DELIVERY',
      goToShop: 'Go to Shop', goToShopDesc: 'Collect the packed order from the shop',
      deliverCustomer: 'Deliver to Customer', deliverCustomerDesc: 'Take the order to the customer address below',
      delivered: 'Delivered!', deliveredDesc: 'Great job — delivery complete',
      pickedUp: 'Picked up from shop', markDelivered: 'Mark delivered',
      orderItems: 'ORDER ITEMS', itemsSubtotal: 'Items subtotal', deliveryFee: 'Delivery fee',
      collectCod: 'Collect (COD)', orderTotal: 'Order total',
      deliverTo: 'DELIVER TO', pickupFrom: 'PICK UP FROM',
      callCustomer: '📞 Call customer', customer: 'CUSTOMER', navigate: '🗺️ Navigate in Google Maps',
      collectCash: '💵 Collect ₹{total} in cash', paidOnline: '✓ Paid online — no cash to collect',
      confirmCod: '✓ Cash collected from customer',
      codRequired: 'Confirm cash collection before marking delivered',
      complete: 'Delivery complete! 🎉', statusUpdated: 'Status updated!',
      updateFailed: 'Failed. Try again.', cancelled: 'Order cancelled by customer',
    },
    history: {
      title: 'Job History 📋', today: 'Today', week: 'This Week', month: 'This Month', all: 'All',
      empty: 'No jobs yet', emptySub: 'Go online to receive delivery requests',
      done: '✓ Done', cash: '💵 Cash', online: '📱 Online',
      deliveryTo: 'Delivery → {address}',
    },
    earnings: {
      title: 'Earnings 💰',
      today: 'Today (delivered)',
      thisWeek: 'This week',
      pendingBalance: 'Pending balance',
      totalPaid: 'Total paid out',
      balanceHint: 'Earnings are based on delivery fees only. Pending balance = all delivered fees minus payouts marked paid by MyTownly admin.',
      payoutHistory: 'Payout history',
      noPayouts: 'No payouts yet — earnings appear here after admin processes daily payouts.',
      paid: '✓ Paid',
      pending: '⏳ Pending',
      deliveries: 'deliveries',
      yesterday: 'Yesterday',
    },
    profile: {
      account: 'Rider', edit: '✏️ Edit', approvedPartner: '✓ Approved Partner', pendingPartner: '⏳ Pending Approval',
      yourVehicle: 'YOUR VEHICLE', vehicleType: 'VEHICLE TYPE', numberPlate: 'NUMBER PLATE',
      saveChanges: 'Save Changes ✅', nameRequired: 'Enter your name', plateRequired: 'Enter vehicle number',
      updated: 'Profile updated! ✅', saveFailed: 'Could not save. Try again.',
      yourStats: 'YOUR STATS', totalJobs: 'Total Jobs', rating: 'Rating', memberSince: 'Member Since',
      workDelivery: '📦 Grocery Delivery',
      helpWhatsapp: 'Chat on WhatsApp', helpWhatsappSub: 'Fastest — we reply within an hour',
      helpCall: 'Call support', helpCallSub: '+91 7730896459',
      terms: 'Terms & Conditions', termsSub: 'Delivery partner agreement',
      notifications: 'Notifications', notificationsSub: 'Order alerts & updates',
      language: 'Language', logout: '🚪 Log Out', loggedOut: 'Logged out',
      version: 'MyTownly Delivery v1.0 · Made with ❤️ in Piler, AP',
    },
  },
  te: {
    appName: 'MyTownly',
    tagline: 'డెలివరీ పార్టనర్ · పిల్లర్',
    langToggle: 'English',
    nav: { home: 'హోమ్', history: 'చరిత్ర', profile: 'ప్రొఫైల్' },
    common: { back: 'వెనుక', save: 'సేవ్', cancel: 'రద్దు', loading: 'లోడ్ అవుతోంది...' },
    notifications: {
      title: 'డెలివరీ అలర్ట్‌లు',
      desc: 'కొత్త పికప్ ఆర్డర్లు సిద్ధమైనప్పుడు పుష్ నోటిఫికేషన్లు పొందండి',
      enable: 'ఆన్ చేయండి',
      enabled: 'నోటిఫికేషన్లు ఆన్! కొత్త డెలివరీ అలర్ట్‌లు వస్తాయి 🔔',
      blocked: 'నోటిఫికేషన్లు బ్లాక్ — ఫోన్ సెట్టింగ్‌లలో ఆన్ చేయండి',
      failed: 'నోటిఫికేషన్లు ఆన్ చేయలేకపోయాము',
    },
    dashboard: {
      online: 'ఆన్‌లైన్', offline: 'ఆఫ్‌లైన్',
      youAreOnline: 'మీరు ఆన్‌లైన్!', youAreOffline: 'మీరు ఆఫ్‌లైన్',
      waitingDelivery: 'డెలివరీ ఆర్డర్ల కోసం వేచి ఉన్నారు...',
      tapOnline: 'ఆన్‌లైన్ కావడానికి ట్యాప్ చేయండి', goOnline: 'ఆన్‌లైన్ కండి →',
      approvalPending: 'ఆమోదం పెండింగ్ ⏳',
      adminApproval: 'ఆన్‌లైన్ కావడానికి అడ్మిన్ ఆమోదం అవసరం',
      approveToast: 'ఆమోదించబడింది! ఇప్పుడు ఆన్‌లైన్ కావచ్చు.',
      blocked: 'మీ ఖాతా బ్లాక్ చేయబడింది. MyTownly సపోర్ట్‌ను సంప్రదించండి.',
      todayJobs: 'నేటి పనులు', totalJobs: 'మొత్తం పనులు',
      rating: 'రేటింగ్', status: 'స్థితి', approved: 'ఆమోదించబడింది ✓', pending: 'పెండింగ్ ⏳',
      noRating: 'కొత్త', ratingValue: '{rating} ⭐',
      waitingApproval: 'ఆమోదం కోసం వేచి ఉన్నారు',
      waitingApprovalSub: 'MyTownly బృందం త్వరలో ఆమోదిస్తుంది. ఆమోదం తర్వాత ఆన్‌లైన్ కావచ్చు.',
      howItWorks: 'ఎలా పని చేస్తుంది',
      tip1: 'షాప్ ఆర్డర్ నిర్ధారించినప్పుడు అంగీకరించండి',
      tip2: 'COD అయితే కస్టమర్ నుండి నగదు సేకరించండి',
      tip3: 'పికప్ చేసి → డెలివర్ చేసి యాప్‌లో మార్క్ చేయండి',
      continueDelivery: 'డెలివరీ కొనసాగుతోంది',
      continueDeliverySub: '{status} — కొనసాగించడానికి ట్యాప్ చేయండి',
      statusReady: 'షాప్‌కు వెళ్లండి', statusPickedUp: 'కస్టమర్‌కు మార్గంలో',
      newDelivery: 'కొత్త డెలివరీ ఆర్డర్', deliverTo: 'డెలివర్ చేయండి',
      acceptDelivery: '✓ డెలివరీ అంగీకరించండి', skip: '✕ దాటవేయి', orderSkipped: 'ఆర్డర్ దాటవేయబడింది',
      deliveryAccepted: 'డెలివరీ అంగీకరించబడింది! 📦', acceptFailed: 'అంగీకరించలేకపోయాము. మళ్ళీ ప్రయత్నించండి.',
      orderTaken: 'ఇప్పటికే మరొక రైడర్ ఈ ఆర్డర్ తీసుకున్నారు', orderNotAvailable: 'ఈ ఆర్డర్ ఇప్పుడు అందుబాటులో లేదు',
      distanceToYou: 'మీకు దూరం', distanceDelivery: 'డెలివరీ దూరం',
      locationDenied: 'లొకేషన్ బ్లాక్ — బ్రౌజర్/ఫోన్ సెట్టింగ్‌లలో rider.mytownly.in కు అనుమతి ఇవ్వండి.',
      locationWeak: 'GPS ఇంకా సిద్ధంగా లేదు — మీరు ఆన్‌లైన్‌లోనే ఉన్నారు. బయటకు వెళ్లండి లేదా కొద్దిసేపు వేచండి.',
    },
    tour: {
      skip: 'దాటవేయి',
      next: 'తర్వాత →',
      gotIt: 'అర్థమైంది! 👍',
      welcomeIcon: '📦',
      welcomeTitle: 'స్వాగతం, డెలివరీ పార్టనర్!',
      welcomeBody: 'ముఖ్యమైన బటన్లు ఎక్కడ ఉన్నాయో చూపిస్తాము — 30 సెకన్లు.',
      onlineIcon: '🟢',
      onlineTitle: 'ఇక్కడ ఆన్‌లైన్ అవ్వండి',
      onlineBody: 'అడ్మిన్ ఆమోదం తర్వాత ఈ సర్కిల్ లేదా Go Online నొక్కండి. లొకేషన్ & నోటిఫికేషన్లు ఇవ్వండి.',
      acceptIcon: '✓',
      acceptTitle: 'డెలివరీలు అంగీకరించండి',
      acceptBody: 'షాప్ Ready గా మార్చినప్పుడు పాపప్ వస్తుంది. ఆర్డర్ కార్డ్‌లో Accept నొక్కండి.',
      deliverIcon: '🏁',
      deliverTitle: 'పూర్తి & చరిత్ర',
      deliverBody: 'యాక్టివ్ స్క్రీన్‌లో Picked up → Delivered మార్క్ చేయండి. గత పనులు క్రింద Historyలో.',
    },
    delivery: {
      active: 'యాక్టివ్ డెలివరీ',
      goToShop: 'షాప్‌కు వెళ్లండి', goToShopDesc: 'షాప్ నుండి ప్యాక్ చేసిన ఆర్డర్ తీసుకోండి',
      deliverCustomer: 'కస్టమర్‌కు డెలివర్', deliverCustomerDesc: 'క్రింది చిరునామాకు ఆర్డర్ తీసుకెళ్లండి',
      delivered: 'డెలివర్ అయింది!', deliveredDesc: 'బాగా చేశారు — డెలివరీ పూర్తి',
      pickedUp: 'షాప్ నుండి పికప్ చేశారు', markDelivered: 'డెలివర్ అయింది అని మార్క్ చేయండి',
      orderItems: 'ఆర్డర్ వస్తువులు', itemsSubtotal: 'వస్తువుల ఉపమొత్తం', deliveryFee: 'డెలివరీ ఫీజు',
      collectCod: 'సేకరించండి (COD)', orderTotal: 'ఆర్డర్ మొత్తం',
      deliverTo: 'డెలివర్ చేయండి', pickupFrom: 'పికప్ చేయండి',
      callCustomer: '📞 కస్టమర్‌కు కాల్', customer: 'కస్టమర్', navigate: '🗺️ Google Mapsలో నావిగేట్',
      collectCash: '💵 ₹{total} నగదు సేకరించండి', paidOnline: '✓ ఆన్‌లైన్ చెల్లించారు — నగదు అవసరం లేదు',
      confirmCod: '✓ కస్టమర్ నుండి నగదు సేకరించబడింది',
      codRequired: 'డెలివర్ మార్క్ చేయడానికి ముందు నగదు సేకరణ నిర్ధారించండి',
      complete: 'డెలివరీ పూర్తి! 🎉', statusUpdated: 'స్థితి అప్‌డేట్ అయింది!',
      updateFailed: 'విఫలమైంది. మళ్ళీ ప్రయత్నించండి.', cancelled: 'కస్టమర్ ఆర్డర్ రద్దు చేశారు',
    },
    history: {
      title: 'పని చరిత్ర 📋', today: 'నేడు', week: 'ఈ వారం', month: 'ఈ నెల', all: 'అన్నీ',
      empty: 'ఇంకా పనులు లేవు', emptySub: 'డెలివరీ అభ్యర్థనల కోసం ఆన్‌లైన్ అవ్వండి',
      done: '✓ పూర్తి', cash: '💵 నగదు', online: '📱 ఆన్‌లైన్',
      deliveryTo: 'డెలివరీ → {address}',
    },
    earnings: {
      title: 'ఆదాయం 💰',
      today: 'నేడు (డెలివర్)',
      thisWeek: 'ఈ వారం',
      pendingBalance: 'పెండింగ్ బ్యాలెన్స్',
      totalPaid: 'మొత్తం చెల్లింపు',
      balanceHint: 'ఆదాయం డెలివరీ ఫీజులపై మాత్రమే. పెండింగ్ = అన్ని డెలివర్ ఫీజులు − అడ్మిన్ చెల్లించిన మొత్తం.',
      payoutHistory: 'చెల్లింపు చరిత్ర',
      noPayouts: 'ఇంకా చెల్లింపులు లేవు — అడ్మిన్ రోజువారీ చెల్లింపు తర్వాత కనిపిస్తుంది.',
      paid: '✓ చెల్లించబడింది',
      pending: '⏳ పెండింగ్',
      deliveries: 'డెలివరీలు',
      yesterday: 'నిన్న',
    },
    profile: {
      account: 'రైడర్', edit: '✏️ మార్చు', approvedPartner: '✓ ఆమోదించబడిన పార్టనర్', pendingPartner: '⏳ ఆమోదం పెండింగ్',
      yourVehicle: 'మీ వాహనం', vehicleType: 'వాహనం రకం', numberPlate: 'నంబర్ ప్లేట్',
      saveChanges: 'మార్పులు సేవ్ ✅', nameRequired: 'మీ పేరు ఇవ్వండి', plateRequired: 'వాహనం నంబర్ ఇవ్వండి',
      updated: 'ప్రొఫైల్ అప్‌డేట్! ✅', saveFailed: 'సేవ్ కాలేదు. మళ్ళీ ప్రయత్నించండి.',
      yourStats: 'మీ గణాంకాలు', totalJobs: 'మొత్తం పనులు', rating: 'రేటింగ్', memberSince: 'సభ్యత్వం నుండి',
      workDelivery: '📦 కిరాణా డెలివరీ',
      helpWhatsapp: 'WhatsApp చాట్', helpWhatsappSub: 'వేగం — సాధారణంగా 1 గంటలో సమాధానం',
      helpCall: 'కాల్ చేయండి', helpCallSub: '+91 7730896459',
      terms: 'నిబంధనలు', termsSub: 'డెలివరీ పార్టనర్ ఒప్పందం',
      notifications: 'నోటిఫికేషన్లు', notificationsSub: 'ఆర్డర్ అలర్ట్‌లు',
      language: 'భాష', logout: '🚪 లాగ్ అవుట్', loggedOut: 'లాగ్ అవుట్ అయ్యారు',
      version: 'MyTownly డెలివరీ v1.0 · పిల్లర్, AP',
    },
  },
};

export const formatT = (str, vars = {}) => {
  if (!str) return '';
  return Object.entries(vars).reduce((s, [k, v]) => s.replace(new RegExp(`\\{${k}\\}`, 'g'), v), str);
};
